export const SET_PAYMENT_GRIDS = 'SET_PAYMENT_GRIDS';
export const RESET_PAYMENT_GRIDS = 'RESET_PAYMENT_GRIDS';
